// This is a generated file - DO NOT EDIT DIRECTLY

export const icons = {
  abv: ` &:before{ content: "\\f101"; } `,
  add: ` &:before{ content: "\\f102"; } `,
  'advanced-notes': ` &:before{ content: "\\f103"; } `,
  alcohol: ` &:before{ content: "\\f104"; } `,
  'alert-circle-filled': ` &:before{ content: "\\f105"; } `,
  'alert-circle': ` &:before{ content: "\\f106"; } `,
  'alert-triangle': ` &:before{ content: "\\f107"; } `,
  amex: ` &:before{ content: "\\f108"; } `,
  'app-subscription': ` &:before{ content: "\\f109"; } `,
  'apple-pay': ` &:before{ content: "\\f10a"; } `,
  armoa: ` &:before{ content: "\\f10b"; } `,
  'arrow-left': ` &:before{ content: "\\f10c"; } `,
  'award-winning': ` &:before{ content: "\\f10d"; } `,
  award: ` &:before{ content: "\\f10e"; } `,
  back: ` &:before{ content: "\\f10f"; } `,
  biodynamic: ` &:before{ content: "\\f110"; } `,
  'birthday-bonus': ` &:before{ content: "\\f111"; } `,
  'blend-type': ` &:before{ content: "\\f112"; } `,
  'bottle-glass': ` &:before{ content: "\\f113"; } `,
  bottle: ` &:before{ content: "\\f114"; } `,
  boxes: ` &:before{ content: "\\f115"; } `,
  'calendar-clock': ` &:before{ content: "\\f116"; } `,
  calendar: ` &:before{ content: "\\f117"; } `,
  camera: ` &:before{ content: "\\f118"; } `,
  'caps-lock': ` &:before{ content: "\\f119"; } `,
  cart: ` &:before{ content: "\\f11a"; } `,
  case: ` &:before{ content: "\\f11b"; } `,
  check: ` &:before{ content: "\\f11c"; } `,
  Checkbox: ` &:before{ content: "\\f11d"; } `,
  cheers: ` &:before{ content: "\\f11e"; } `,
  'chevron-down': ` &:before{ content: "\\f11f"; } `,
  'chevron-left': ` &:before{ content: "\\f120"; } `,
  'chevron-right': ` &:before{ content: "\\f121"; } `,
  'chevron-up': ` &:before{ content: "\\f122"; } `,
  chocolate: ` &:before{ content: "\\f123"; } `,
  'choice-check': ` &:before{ content: "\\f124"; } `,
  'choice-uncheck': ` &:before{ content: "\\f125"; } `,
  'circle-chevron-left': ` &:before{ content: "\\f126"; } `,
  'circle-chevron-right': ` &:before{ content: "\\f127"; } `,
  'circle-filled': ` &:before{ content: "\\f128"; } `,
  'clear-circle': ` &:before{ content: "\\f129"; } `,
  close: ` &:before{ content: "\\f12a"; } `,
  'convenient-delivery': ` &:before{ content: "\\f12b"; } `,
  'cork-screw': ` &:before{ content: "\\f12c"; } `,
  coupons: ` &:before{ content: "\\f12d"; } `,
  'credit-card': ` &:before{ content: "\\f12e"; } `,
  'customer-services': ` &:before{ content: "\\f12f"; } `,
  customize: ` &:before{ content: "\\f130"; } `,
  'customized-selections': ` &:before{ content: "\\f131"; } `,
  delete: ` &:before{ content: "\\f132"; } `,
  diamond: ` &:before{ content: "\\f133"; } `,
  discover: ` &:before{ content: "\\f134"; } `,
  'dot-menu': ` &:before{ content: "\\f135"; } `,
  'dots-menu': ` &:before{ content: "\\f136"; } `,
  droplet: ` &:before{ content: "\\f137"; } `,
  edit: ` &:before{ content: "\\f138"; } `,
  email: ` &:before{ content: "\\f139"; } `,
  'envelope-box': ` &:before{ content: "\\f13a"; } `,
  envelope: ` &:before{ content: "\\f13b"; } `,
  expand: ` &:before{ content: "\\f13c"; } `,
  eye: ` &:before{ content: "\\f13d"; } `,
  facebook: ` &:before{ content: "\\f13e"; } `,
  'file-user': ` &:before{ content: "\\f13f"; } `,
  filter: ` &:before{ content: "\\f140"; } `,
  flexibility: ` &:before{ content: "\\f141"; } `,
  'free-delivery': ` &:before{ content: "\\f142"; } `,
  gift: ` &:before{ content: "\\f143"; } `,
  glass: ` &:before{ content: "\\f144"; } `,
  glasses: ` &:before{ content: "\\f145"; } `,
  'google-pay': ` &:before{ content: "\\f146"; } `,
  grape: ` &:before{ content: "\\f147"; } `,
  'green-tick': ` &:before{ content: "\\f148"; } `,
  'hamburger-menu': ` &:before{ content: "\\f149"; } `,
  'hand-truck': ` &:before{ content: "\\f14a"; } `,
  'heart-solid': ` &:before{ content: "\\f14b"; } `,
  heart: ` &:before{ content: "\\f14c"; } `,
  'help-circle': ` &:before{ content: "\\f14d"; } `,
  'hide-password': ` &:before{ content: "\\f14e"; } `,
  home: ` &:before{ content: "\\f14f"; } `,
  'homepage-customisation': ` &:before{ content: "\\f150"; } `,
  'info-circle': ` &:before{ content: "\\f151"; } `,
  'information-circle': ` &:before{ content: "\\f152"; } `,
  instagram: ` &:before{ content: "\\f153"; } `,
  kosher: ` &:before{ content: "\\f154"; } `,
  'label-scanner': ` &:before{ content: "\\f155"; } `,
  'last-sold-bg': ` &:before{ content: "\\f156"; } `,
  'ligntning-solid': ` &:before{ content: "\\f157"; } `,
  'linked-in': ` &:before{ content: "\\f158"; } `,
  'live-chat': ` &:before{ content: "\\f159"; } `,
  'location-dotted': ` &:before{ content: "\\f15a"; } `,
  location: ` &:before{ content: "\\f15b"; } `,
  mastercard: ` &:before{ content: "\\f15c"; } `,
  menu: ` &:before{ content: "\\f15d"; } `,
  minus: ` &:before{ content: "\\f15e"; } `,
  'money-back-apac': ` &:before{ content: "\\f15f"; } `,
  'money-back-us': ` &:before{ content: "\\f160"; } `,
  'money-back': ` &:before{ content: "\\f161"; } `,
  mute: ` &:before{ content: "\\f162"; } `,
  'no-obligation': ` &:before{ content: "\\f163"; } `,
  'offset-carbon': ` &:before{ content: "\\f164"; } `,
  organic: ` &:before{ content: "\\f165"; } `,
  'packaging-pioneer': ` &:before{ content: "\\f166"; } `,
  'pad-lock-benefits': ` &:before{ content: "\\f167"; } `,
  padlock: ` &:before{ content: "\\f168"; } `,
  pause: ` &:before{ content: "\\f169"; } `,
  paypal: ` &:before{ content: "\\f16a"; } `,
  'phone-arrow': ` &:before{ content: "\\f16b"; } `,
  'phone-solid': ` &:before{ content: "\\f16c"; } `,
  phone: ` &:before{ content: "\\f16d"; } `,
  pioneer: ` &:before{ content: "\\f16e"; } `,
  placeholder: ` &:before{ content: "\\f16f"; } `,
  'play-video': ` &:before{ content: "\\f170"; } `,
  play: ` &:before{ content: "\\f171"; } `,
  print: ` &:before{ content: "\\f172"; } `,
  'question-circle': ` &:before{ content: "\\f173"; } `,
  'radio-selected': ` &:before{ content: "\\f174"; } `,
  radio: ` &:before{ content: "\\f175"; } `,
  'red-alert-circle-filled': ` &:before{ content: "\\f176"; } `,
  'restaurant-dishes': ` &:before{ content: "\\f177"; } `,
  rossette: ` &:before{ content: "\\f178"; } `,
  'sale-tag-benefits': ` &:before{ content: "\\f179"; } `,
  'sale-tag': ` &:before{ content: "\\f17a"; } `,
  sale: ` &:before{ content: "\\f17b"; } `,
  'satisfaction-guarantee': ` &:before{ content: "\\f17c"; } `,
  saving: ` &:before{ content: "\\f17d"; } `,
  savings: ` &:before{ content: "\\f17e"; } `,
  search: ` &:before{ content: "\\f17f"; } `,
  share: ` &:before{ content: "\\f180"; } `,
  sort: ` &:before{ content: "\\f181"; } `,
  'star-solid': ` &:before{ content: "\\f182"; } `,
  star: ` &:before{ content: "\\f183"; } `,
  'stwc-blog': ` &:before{ content: "\\f184"; } `,
  'subscribe-save': ` &:before{ content: "\\f185"; } `,
  sustainable: ` &:before{ content: "\\f186"; } `,
  target: ` &:before{ content: "\\f187"; } `,
  thumb_down: ` &:before{ content: "\\f188"; } `,
  'thumbs-down-solid': ` &:before{ content: "\\f189"; } `,
  'thumbs-down': ` &:before{ content: "\\f18a"; } `,
  'thumbs-up-solid': ` &:before{ content: "\\f18b"; } `,
  'thumbs-up': ` &:before{ content: "\\f18c"; } `,
  'tick-circle-solid': ` &:before{ content: "\\f18d"; } `,
  'tick-circle': ` &:before{ content: "\\f18e"; } `,
  ticket: ` &:before{ content: "\\f18f"; } `,
  trending: ` &:before{ content: "\\f190"; } `,
  'truck-benefits': ` &:before{ content: "\\f191"; } `,
  'truck-solid': ` &:before{ content: "\\f192"; } `,
  truck: ` &:before{ content: "\\f193"; } `,
  trust: ` &:before{ content: "\\f194"; } `,
  twitter: ` &:before{ content: "\\f195"; } `,
  'unidentified-country': ` &:before{ content: "\\f196"; } `,
  units: ` &:before{ content: "\\f197"; } `,
  'unlimited-avr': ` &:before{ content: "\\f198"; } `,
  'unlimited-sale': ` &:before{ content: "\\f199"; } `,
  'unlimited-save': ` &:before{ content: "\\f19a"; } `,
  'unlimited-stwc': ` &:before{ content: "\\f19b"; } `,
  'unlimited-truck': ` &:before{ content: "\\f19c"; } `,
  unlimited: ` &:before{ content: "\\f19d"; } `,
  unltCheckIcon: ` &:before{ content: "\\f19e"; } `,
  user: ` &:before{ content: "\\f19f"; } `,
  vegan: ` &:before{ content: "\\f1a0"; } `,
  vegetarian: ` &:before{ content: "\\f1a1"; } `,
  views: ` &:before{ content: "\\f1a2"; } `,
  vinny: ` &:before{ content: "\\f1a3"; } `,
  visa: ` &:before{ content: "\\f1a4"; } `,
  warning: ` &:before{ content: "\\f1a5"; } `,
  'wine-colour': ` &:before{ content: "\\f1a6"; } `,
  'wine-glass': ` &:before{ content: "\\f1a7"; } `,
  world: ` &:before{ content: "\\f1a8"; } `,
  'x-twitter': ` &:before{ content: "\\f1a9"; } `,
  youtube: ` &:before{ content: "\\f1aa"; } `,
  zoom: ` &:before{ content: "\\f1ab"; } `,
};
